import { useEffect, useRef, useState } from "react";

import "./status-filter.styles.scss";

import { statusOptions } from "../../assets/ticket-options";

const defaultFilter = [
  "Resolved",
  "Resolved - BER",
  "Resolved - Buyout",
  "Resolved - Canceled",
  "Resolved - Denied",
  "Resolved- Shipped",
  "Resolved - Unable To Repair",
];

const StatusFilter = ({ currentStatuses, setStatuses }) => {
  
  // State for dropdown visibility remains
  const [dropdown, setDropdown] = useState(false);
  const menuRef = useRef();

  // NEW: Initial synchronization logic.
  // We only apply the default filter if the parent state is truly empty (first ever load).
  // useEffect(() => {
  //   if (currentStatuses && currentStatuses.length === 0) {
  //     // Check if this is a load where no filter was previously set (i.e., local storage was empty)
  //     // Note: A true persistent empty array (user cleared all) is handled by the fetch logic below.
  //     // This ensures a default set is applied on the FIRST ever load.
  //     if (currentStatuses.length === 0) {
  //         setStatuses(defaultFilter);
  //     }
  //   }
  // }, [currentStatuses, setStatuses]); 



  useEffect(() => {
    let handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleOptionsSelect = (event) => {
    const value = event.target.value;
    
    const isCurrentlySelected = currentStatuses.includes(value);
    let newSelectedOptions;

    if (isCurrentlySelected) {
      // UNCHECK: Filter out the value
      newSelectedOptions = currentStatuses.filter((option) => option !== value);
    } else {
      // CHECK: Add the value
      newSelectedOptions = [...currentStatuses, value];
    }

    setStatuses(newSelectedOptions); 
  };

  const handleClick = () => {
    setDropdown(!dropdown);
  };

  return (
    <div className="status-filter" ref={menuRef}>
      <label className={`filter-status-label`}>Status Filter</label>
      <div className="dropdown-container" onClick={handleClick}>
        {currentStatuses.length} Selected 
      </div>
      <div className={`status-list ${!dropdown ? "hidden" : ""}`}>
        {statusOptions.map((option) => (
          <div key={option} className="status-input-container">
            <input
              type="checkbox"
              id={option}
              name={option}
              value={option}
              checked={currentStatuses.includes(option)} // Use currentStatuses
              onChange={handleOptionsSelect}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;